import { useBranchList } from "CRM/hooks/GetBranchList";
import { useEmployee } from "CRM/hooks/GetEmployee";
import { Icon } from "CRM/organism/Main/styles";
import { Checkbox, Input, Select, message } from "antd";
import { useToken } from "app/hooks";
import React, { useEffect, useState } from "react";
import { FaChevronLeft } from "react-icons/fa6";
import API from "utils/api";
import { useTeamList } from "../../hooks/GetTeamList";
import { Blacked, DBModalContent, DBModalInput, DBModalInputLine, DBModalInputWrap, ModalHeader, ModalSubmit, ModalTitle, ModalWrapper } from "../styles";
import { useIsMobile } from "../IsMobile";

export const EmployeeEdit = ({ userId, setUserId, mutate }) => {
	const IsMobile = useIsMobile();
	const { data: token } = useToken();
	const { branchList } = useBranchList();
	const { teamList } = useTeamList();

	const { employee } = useEmployee(userId);
	const [name, setName] = useState(employee?.name || "");
	const [password, setPassword] = useState(employee?.password || "");
	const [email, setEmail] = useState(employee?.email || "");
	const [tel, setTel] = useState(employee?.tel || "");
	const [memo, setMemo] = useState(employee?.memo || "");
	const [branch, setBranch] = useState(employee?.branchId || null);
	const [team, setTeam] = useState(employee?.teamId || null);

	const [leader, setLeader] = useState(employee?.leader || false);
	const [teamLeader, setTeamLeader] = useState(employee?.teamLeader || false);

	useEffect(() => {
		setName(employee?.name || "");
		setPassword(employee?.password || "");
		setEmail(employee?.email || "");
		setTel(employee?.tel || "");
		setMemo(employee?.memo || "");
		setBranch(employee?.branchId || null);
		setTeam(employee?.teamId || null);
		setLeader(employee?.leader || false);
		setTeamLeader(employee?.teamLeader || false);

		mutate();
	}, [employee, mutate]);

	const clickSubmit = () => {
		const shouldEdit = window.confirm(`직원을 수정하시겠습니까?`);
		if (shouldEdit) {
			if (name == "") {
				message.error("이름은 필수 입력입니다.");
			} else {
				API.put("/admin/" + userId, token + "", {
					datas: {
						name: name,
						email: email,
						password: password,
						tel: tel,
						memo: memo,
						branchId: branch,
						teamId: team,
						leader: leader,
						teamLeader: teamLeader,
					},
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("수정되었습니다");
							mutate();
							setUserId(null);
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	return (
		<>
			<Blacked onClick={() => setUserId(null)} />
			{IsMobile ? (
				<ModalWrapper IsMobile={IsMobile}>
					<ModalHeader>
						<Icon onClick={() => setUserId(null)}>
							<FaChevronLeft />
						</Icon>
						<ModalTitle>직원 정보</ModalTitle>
						<ModalSubmit onClick={clickSubmit}>수정</ModalSubmit>
					</ModalHeader>
					<DBModalContent>
						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>이름 *</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={name}
										onChange={(e) => setName(e.target.value)}
										placeholder="이름을 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>연락처</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={tel}
										onChange={(e) => setTel(e.target.value)}
										placeholder="연락처를 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>비밀번호</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										placeholder="비밀번호를 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>지점</label>
								<DBModalInputWrap>
									<Select value={branch} onChange={(e) => setBranch(e)}>
										{process.env.REACT_APP_API_URL?.includes("ccl") && (
											<option style={{ fontFamily: "Pretendard" }} value={1}>
												본사
											</option>
										)}
										{branchList?.map((it) => (
											<option style={{ fontFamily: "Pretendard" }} value={it.id}>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>팀</label>
								<DBModalInputWrap>
									<Select value={team} onChange={(e) => setTeam(e)}>
										<option style={{ fontFamily: "Pretendard" }} value={""}>
											없음
										</option>
										{teamList
											?.filter((it) => it.branchId == branch)
											?.map((it) => (
												<option style={{ fontFamily: "Pretendard" }} value={it.id}>
													{it.name}
												</option>
											))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>이메일</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										placeholder="이메일을 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>메모</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={memo}
										onChange={(e) => setMemo(e.target.value)}
										placeholder="메모를 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>지사장</label>
								<DBModalInputWrap>
									<Checkbox
										checked={leader}
										onChange={(e) => {
											setLeader(e.target.checked);
											setTeamLeader(false);
										}}
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label>팀장</label>
								<DBModalInputWrap>
									<Checkbox
										checked={teamLeader}
										onChange={(e) => {
											setLeader(false);
											setTeamLeader(e.target.checked);
										}}
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
					</DBModalContent>
				</ModalWrapper>
			) : (
				<ModalWrapper style={{ minHeight: 300 }}>
					<ModalHeader>
						<Icon onClick={() => setUserId(null)}>
							<FaChevronLeft />
						</Icon>
						<ModalTitle>직원 정보</ModalTitle>
						<ModalSubmit onClick={clickSubmit}>수정</ModalSubmit>
					</ModalHeader>
					<DBModalContent>
						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>이름 *</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={name}
										onChange={(e) => setName(e.target.value)}
										placeholder="이름을 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label style={{ padding: 20 }}>연락처</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={tel}
										onChange={(e) => setTel(e.target.value)}
										placeholder="연락처를 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>비밀번호</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										placeholder="비밀번호를 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>지점</label>
								<DBModalInputWrap>
									<Select value={branch} onChange={(e) => setBranch(e)}>
										{process.env.REACT_APP_API_URL?.includes("ccl") && (
											<option style={{ fontFamily: "Pretendard" }} value={1}>
												본사
											</option>
										)}

										{branchList?.map((it) => (
											<option style={{ fontFamily: "Pretendard" }} value={it.id}>
												{it.name}
											</option>
										))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label style={{ padding: 20 }}>팀</label>
								<DBModalInputWrap>
									<Select value={team} onChange={(e) => setTeam(e)}>
										<option style={{ fontFamily: "Pretendard" }} value={""}>
											없음
										</option>
										{teamList
											?.filter((it) => it.branchId == branch)
											?.map((it) => (
												<option style={{ fontFamily: "Pretendard" }} value={it.id}>
													{it.name}
												</option>
											))}
									</Select>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>
						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>이메일</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										placeholder="이메일을 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
							<DBModalInput>
								<label style={{ padding: 20 }}>메모</label>
								<DBModalInputWrap>
									<Input
										type="text"
										value={memo}
										onChange={(e) => setMemo(e.target.value)}
										placeholder="메모를 입력해주세요."
									/>
								</DBModalInputWrap>
							</DBModalInput>
						</DBModalInputLine>

						<DBModalInputLine>
							<DBModalInput>
								<label style={{ padding: 20 }}>지사장</label>
								<Checkbox
									checked={leader}
									onChange={(e) => {
										setLeader(e.target.checked);
										setTeamLeader(false);
									}}
								/>
							</DBModalInput>
							<DBModalInput>
								<label style={{ padding: 20 }}>팀장</label>
								<Checkbox
									checked={teamLeader}
									onChange={(e) => {
										setLeader(false);
										setTeamLeader(e.target.checked);
									}}
								/>
							</DBModalInput>
						</DBModalInputLine>
					</DBModalContent>
				</ModalWrapper>
			)}
		</>
	);
};

export default React.memo(EmployeeEdit);
